import {Card, CardContent, CardFooter} from "@/components/ui/card";
import {Link} from "react-router";
import {cn} from "@/lib/utils";


export interface StateCardProps {
    className?: string;
    title: string;
    value: string;
    link: string;
    linkText: string;
}


export function StateCard(props: StateCardProps) {

    const {
        className,
        title = "כותרת",
        value = "10,815",
        link,
        linkText,
    } = props;

    return (
        <Card>
            <CardContent className="px-9">
                <div className="flex flex-col px-2">
                    <div className="font-sm font-normal text-gray-500">
                        {title}
                    </div>
                    <div className="text-4xl font-medium text-gray-900">
                        {value}
                    </div>
                </div>
            </CardContent>
            <CardFooter className="px-9">
                <a href={link} className="text-sm text-light-blue-600">
                    {linkText}
                </a>
            </CardFooter>
        </Card>
    )
}


export interface GroupStatesProps {
    className?: string;
    children: React.ReactNode;
}
export function GroupStates(props: GroupStatesProps) {
    return (
            <Card>
                <CardContent
                    className={cn(props.className,
                        'grid grid-cols-3 !p-0 divide-x-[0.11rem] divide-gray-300/50',
                        '[&>*]:rounded-none  [&>*]:shadow-none'
                    )}
                >
                    {props.children}
                </CardContent>
            </Card>
    )
}
